import {Component, EventEmitter, forwardRef, Input, OnChanges, Output, Provider, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SelectOption} from '@shared/module/forms/component/form-select/select-option';

const SELECT_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormSelectComponent),
  multi: true,
};

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss'],
  providers: [SELECT_CONTROL_VALUE_ACCESSOR]
})
export class FormSelectComponent implements ControlValueAccessor, OnChanges {
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() options!: SelectOption[];
  @Input() translateKey: string = '';
  @Input() type: string = 'default';
  @Input() required: boolean = false;
  @Output() onSelectValue = new EventEmitter<any>();

  show = false;
  selected?: any
  disabled = false;

  private onTouched!: Function;
  private onChanged: Function = () => {};

  ngOnChanges(changes: SimpleChanges) {
    const selected = this.options?.find(o => o.selected);
    if (selected) {
      this.writeValue(selected);
    }
  }

  selectValue(option: SelectOption) {
    this.show = false;
    this.selected = option;
    this.onSelectValue.emit(option.value);
    this.onChanged(option.value); // <-- call function to let know of a change
  }

  writeValue(option: SelectOption): void {
    this.selected = option ?? undefined;
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn; // <-- save the function
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn; // <-- save the function
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
}
